import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  resetPersonalInfoFormData,
} from "../../store/personalInfoSlice"; 
import { logout } from "../../store/authSlice";
import {  resetFormData } from "../../store/supplierFormDataSlice";
import { resetBuyerFormData } from "../../store/buyerFormDataSlice";

const LogoutPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const doLogout = async () => {
      dispatch(resetFormData());
      dispatch(resetBuyerFormData());
      dispatch(resetPersonalInfoFormData());
      dispatch(logout());

      navigate("/login");
    };

    doLogout();
  }, [dispatch, navigate]);

  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      <h2>Logging out...</h2>
    </div>
  );
};

export default LogoutPage;
